// import React, { useEffect } from "react";

import PropTypes from "prop-types";
import { useEffect } from "react";

// const TawkToChat = () => {


//   useEffect(() => {
//     // Only inject once
//     if (document.getElementById("tawkToScript")) return;

//     const script = document.createElement("script");
//     script.id = "tawkToScript";
//     script.async = true;
//     script.src = "https://embed.tawk.to/688af64a9c4b3719280d204b/1j1fd459q";
//     script.setAttribute("crossorigin", "*");

//     document.body.appendChild(script);
//   }, []);

//   return null; // no DOM rendering needed
// };

// export default TawkToChat;

const TawkToChat = ({ userId, name, email }) => {

    useEffect(() => {
        // Prevent duplicate injection
        if (document.getElementById("tawkToScript")) return;
        const propertyId = process.env.REACT_APP_TAWK_PROPERTY_ID;
        const widgetId = process.env.REACT_APP_TAWK_WIDGET_ID;
        const script = document.createElement("script");
        script.id = "tawkToScript";
        script.async = true;
        script.src = `https://embed.tawk.to/${propertyId}/${widgetId}`;
        script.setAttribute("crossorigin", "*");

        document.body.appendChild(script);

        // Optional: Add Tawk user info
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_API.onLoad = function () {
            const hideMenu = () => {
                const iframe = document.getElementById("tawk-messenger-frame");
                if (iframe) {
                    try {
                        const menuBtn = iframe.contentDocument?.querySelector('[aria-label="Menu"]');
                        if (menuBtn) menuBtn.style.display = "none";
                    } catch (e) {
                        console.warn("Tawk iframe is cross-domain, cannot access directly");
                    }
                }
            };
            setTimeout(hideMenu, 1000);
            window.Tawk_API.setAttributes(
                {
                    name,
                    email,
                    hash: "", // Optional if you use Tawk Secure Mode
                },
                function (error) {
                    if (error) console.error("Tawk user set error", error);
                }
            );
        };
    }, [userId, name, email]);

    return null;
};

TawkToChat.propTypes = {
    userId: PropTypes.any.isRequired,
    name: PropTypes.any,
    email: PropTypes.any
}

export default TawkToChat;